var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deleteAssetAlias from '../../requests/asset/deleteAssetAlias';
/**
 *
 */
var DeleteAssetAliasCommand = /** @class */ (function (_super) {
    __extends(DeleteAssetAliasCommand, _super);
    function DeleteAssetAliasCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param assetModel ManualAssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    DeleteAssetAliasCommand.prototype.execute = function (assetModel, organisationId, intl) {
        var promise = deleteAssetAlias(organisationId, assetModel.getMetricsDbId());
        this.intl = intl;
        this.assetModel = assetModel;
        return promise;
    };
    return DeleteAssetAliasCommand;
}(Command));
export default DeleteAssetAliasCommand;
